// Ruta: frontend/src/modules/inspections/pages/ScannerPage.tsx
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQRScanner } from '@core/hooks/useQRScanner';
import { Button } from '@shared/components/Button';

const ScannerPage: React.FC = () => {
  const navigate = useNavigate();
  const { scan, isScanning, error, stopScanning } = useQRScanner();
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    const startScan = async () => {
      try {
        const result = await scan('qr-reader');
        if (result && isMounted.current) {
          // ✅ Guardar (opcional) y redirigir a la página de inspección con recarga
          localStorage.setItem('qrResult', result); // por si acaso
          window.location.href = `/inspection/${encodeURIComponent(result)}`;
        }
      } catch (err) {
        console.error('Error al escanear:', err);
        if (isMounted.current) stopScanning();
      }
    };

    startScan();

    return () => {
      isMounted.current = false;
      stopScanning();
    };
  }, [scan, stopScanning]);

  return (
    <div className="max-w-lg mx-auto space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Escanear QR</h1>
      <div className="bg-white rounded-lg shadow p-4">
        <div id="qr-reader" className="w-full aspect-square bg-gray-100 rounded-lg" />
      </div>
      {error && (
        <div className="rounded-md bg-red-50 p-4">
          <p className="text-sm text-red-800">{error}</p>
        </div>
      )}
      {isScanning && <div className="text-center text-gray-500">Escaneando...</div>}
      <div className="flex space-x-3">
        <Button
          variant="secondary"
          onClick={() => {
            stopScanning();
            navigate('/');
          }}
          fullWidth
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
};

export default ScannerPage;